var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"already-tips"},[_c('img',{attrs:{"src":"//res13.xesimg.com/x5mall/img/login-tips_new.png","alt":""}}),_c('span',[_vm._v("已帮您选择难度")]),_c('em'),_c('i',{staticClass:"iconfont1 icon-guanbi",on:{"click":function($event){$event.stopPropagation();return _vm.closeSelf.apply(null, arguments)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-962e6c88","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CourseCenter/components/AlreadyDegree.vue
// module id = 1013
// module chunks = 1